import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Breadcrumb, BreadcrumbData, Asset, Event } from '@app/core/interfaces';
import { AssetsService } from '@app/services/assets.service';
import { EventsService } from '@app/services/events.service';

@Component({
  selector: 'app-breadcrumb-alert',
  templateUrl: './breadcrumb-alert.component.html',
  styleUrl: './breadcrumb-alert.component.scss',
})
export class BreadcrumbAlertComponent {
  @Output() public navigateEvent = new EventEmitter<Breadcrumb>();

  @Input() alertIdentifier!: BreadcrumbData;
  alert!: Event;

  constructor(public eventsService: EventsService) {}

  //ngOnChanges fires at the same time ngOnInit would at start
  ngOnChanges(changes: SimpleChanges): void {
    this.eventsService.initializeService();
    this.getEventData();
  }

  getEventData() {
    this.eventsService
      .getEventById(this.alertIdentifier.ID)
      .subscribe((res: any) => {
        this.alert = res;
      });
  }

  navigateTo(bc: Breadcrumb) {
    this.navigateEvent.emit(bc);
  }

  getUseCase(): string {
    return window.location.pathname.split('/')[1];
  }
}
